<div class="modal-content">
  <h1 class="modal__heading">{{ 'credit-card-error-modal-title' | translate }}</h1>
  <p class="modal__paragraph">{{ 'credit-card-error-modal-info-1' | translate }}</p>
  <p class="modal__paragraph">{{ 'credit-card-error-modal-info-2' | translate }}</p>
  <button class="btn__primary--inverted" tabindex="0" (click)="closeModal('credit-card-error-modal')">
    {{ 'close' | translate }}
  </button>
</div>
